
  import React from "react"
  import Component from "/home/travis/build/signalwerk/doc-starter/src/layouts/index.js"
  import data from "/home/travis/build/signalwerk/doc-starter/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js